var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_3",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M771.75,455.82a444.36,444.36,0,0,0-9.78-59C749.48,403.39,689.4,465,631.13,400s27.14-118.66-13-219.16S382.5,22,382.5,22s22,283-174.34,332.91C11.18,405-6.8,583.74,44.8,710.68,85,809.46,188.12,902.29,299.72,936.57,242.21,898.76,200,821.9,200,729.72c0-138,180.62-240.85,180.62-240.85S347.43,632.19,487.11,633.56c53.21.52,104.48,35.86,92.73,138.75-8,69.73-41.69,131.6-95.85,164.26,99.51-24.51,173-90.51,229.74-183.75C786.42,633.3,780.92,549.6,771.75,455.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaze);
export default __webpack_public_path__ + "static/media/Gaze.eed0d2fbd7274ac5a7967cfddd4cff69.svg";
export { ForwardRef as ReactComponent };